export const brokerageUserKeys = {
  brokerageUser: ['brokerageUser'] as const,
  search: (brokerageId: string, query: string) => ['brokerageUser', { brokerageId }, query] as const,
  searchPaginated: (requestParams: any, query: string) =>
    ['brokerageUser', { brokerageId: requestParams?.brokerageId }, query] as const,
};

export const brokerageProducerKeys = {
  brokerageProducer: ['brokerageProducer'] as const,
  searchPaginated: (requestParams: any, query: string) =>
    ['brokerageProducer', { brokerageId: requestParams?.brokerageId }, query] as const,
};
